// extracted by mini-css-extract-plugin
module.exports = {"nodata":"NoData_nodata__2K_2L"};